// extracted by mini-css-extract-plugin
export default {"container":"productMeasuresDetail_container__YXMsu"};